module.exports = __webpack_public_path__ + "static/media/firma_voytenco.48409d51.jpg";